import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import Modal from './Modal';
import Field from './Field';
import Checkbox from './Checkbox';

const PasswordModal = ({ filename, processing, error, onCancel, onSubmit }) => {
  const { t } = useTranslation(['common', 'convert-and-edit']);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { basePath } = useRouter();

  const handlePasswordVisibleCheckboxToggle = useCallback(() => {
    setPasswordVisible((passwordVisible) => !passwordVisible);
  }, []);

  return (
    <Modal
      as="form"
      show
      title={t('convert-and-edit:password-modal.title')}
      text={t('convert-and-edit:password-modal.text', {
        filename,
        interpolation: {
          escapeValue: true,
        },
      })}
      modalBodyProps={{
        onSubmit: handleSubmit(onSubmit),
        style: {
          backgroundImage: `url(${basePath}/images/password-modal.svg)`,
        },
      }}
      cancelButtonProps={{
        onClick: onCancel,
      }}
      okButtonProps={{
        type: 'submit',
        disabled: processing,
        children: t('common:modal.confirm'),
      }}
    >
      <Field size="md" isError={!!(errors.password || error)}>
        <Field.Input
          type={passwordVisible ? 'text' : 'password'}
          placeholder={t('convert-and-edit:password-modal.placeholder')}
          autoComplete="off"
          {...register('password', {
            required: true,
          })}
        />
        {(errors.password || error) && (
          <Field.Error>
            {t('convert-and-edit:password-modal.error')}
          </Field.Error>
        )}
      </Field>
      <Checkbox
        inputProps={{
          checked: passwordVisible,
          onChange: handlePasswordVisibleCheckboxToggle,
        }}
      >
        {t('convert-and-edit:password-modal.checkbox')}
      </Checkbox>
    </Modal>
  );
};

PasswordModal.propTypes = {
  filename: PropTypes.string.isRequired,
  processing: PropTypes.bool,
  error: PropTypes.bool,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

export default PasswordModal;
